import { blogSeoMetadata } from '../data/blogSeoMetadata';

export const publicPagePaths = [
  '/', '/companion-app', '/llm-info',
  '/platform/biomarker-informed-nutrition', '/personalised-nutrition-platform',
  '/terms', '/platform-terms', '/privacy', '/platform-privacy', '/cookies',
  '/founding-circle-agreement', '/data-processing-agreement', '/practitioner-declaration-consent',
];
export const marketingPaths = [...publicPagePaths, ...blogSeoMetadata.map(post => post.href)];
export const isMarketingPath = (pathname: string) => marketingPaths.includes(pathname);
